import React from 'react';

const Social = () => {
  return (
   <div className="home__social">
    <a href="https://www.instagram.com/hii_prabhat/" className="home__social-icon" target="_blank">
    <i className="uil uil-instagram"></i>
    </a>

    <a href="" className="home__social-icon" target="_blank">
    <i className="uil uil-dribbble"></i>
    </a>

    <a href="https://github.com/Prabhat-022" className="home__social-icon" target="_blank">
    <i className="uil uil-github-alt"></i>
    </a>

    <a href="https://twitter.com/lograjanand" className="home__social-icon" target="_blank">
    <i class="uil uil-twitter-alt"></i>
    </a>

   </div>
  )
}

export default Social;
